import React, { useState, useRef, useCallback } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Collapse } from 'react-bootstrap';
import cx from 'classnames';
import messages from '../../locale/messages';
import { AngleDownArrowIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';
import bt from '../../components/commonStyle.css';

function ShowDescription({ description, className, count, containerClass }) {
  const [open, setOpen] = useState(false);
  const descriptionRef = useRef(null);

  const handleClick = useCallback(
    e => {
      e.preventDefault();
      setOpen(prev => {
        const next = !prev;
        if (!next && descriptionRef.current) {
          descriptionRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
        return next;
      });
    },
    [setOpen]
  );

  const firstArray = description?.slice(0, count) || '';
  const restArray = description?.slice(count) || '';
  const hasOverflow = restArray.length > 0;

  return (
    <div
      className={hasOverflow ? containerClass : undefined}
      ref={descriptionRef}
    >
      <div className={className}>
        {!open && count >= 250 && (
          <span>
            {firstArray}
            {hasOverflow && '…'}
          </span>
        )}
        {hasOverflow && (
          <span>
            <Collapse in={open}>
              <div>
                {open && firstArray}
                {restArray}
              </div>
            </Collapse>
          </span>
        )}
      </div>
      {hasOverflow && <div className="d-flex">
        <a
          href="#"
          onClick={handleClick}
          className={cx(bt.commonLinkWithIcon, open && bt.commonLinkIconRotate)}
        >
          {open ? (
            <FormattedMessage {...messages.showLessText} />
          ) : (
            <FormattedMessage {...messages.showMoreText} />
          )}
          <AngleDownArrowIcon />
        </a>
      </div>}
    </div>
  );
}


export default injectIntl(withStyles(bt)(ShowDescription));
